<div class="container">
  <loader *ngIf="loading"></loader>
  <div *ngIf="!loading && refOptions.length > 0">
<div style="display: flex; flex-direction: row; gap: 5px; margin-bottom: 5px">
  <span>{{ "translate.manage-content.filterBy" | translate }}</span>
  <p-radioButton
    name="filter"
    value="all"
    [(ngModel)]="selectedValue"
    inputId="all"
    (onClick)="onFilterChange('all')"
  ></p-radioButton>
  <label for="all">{{ "translate.claim-tool.doc-ref-options.all-filter" | translate }}</label>

  <p-radioButton
    name="filter"
    value="REFERENCE"
    [(ngModel)]="selectedValue"
    inputId="reference"
    (onClick)="onFilterChange('REFERENCE')"
  ></p-radioButton>
  <label for="reference">{{ "translate.claim-tool.doc-ref-options.reference-filter" | translate }}</label>

  <p-radioButton
    name="filter"
    value="FOOTNOTE"
    [(ngModel)]="selectedValue"
    inputId="footnote"
    (onClick)="onFilterChange('FOOTNOTE')"
  >FOOTNOTE</p-radioButton>
  <label for="footnote">{{ "translate.claim-tool.doc-ref-options.footnote-filter" | translate }}</label>
</div>
  </div>
  <ui-table style="margin-top: 10px; margin-bottom: 10px"
    *ngIf="!loading"
    class="t-small"
    [isWrapped]="false"
    [data]="displayedRefOptions"
    [templates]="[
      {
        title: 'translate.general.text',
        template: phraseText
      },
      {
        title: 'translate.claim-tool.doc-ref-options.ref-type-column',
        template: ref_type
      },
      {
        title: 'translate.general.actions',
        template: is_phrase_ref
      }
    ]"
  ></ui-table>
</div>

<ng-template #phraseText let-row="row">
  <!-- {{ row.phraseText }} -->
    {{ row.phrase_text }}
</ng-template>
<ng-template #ref_type let-row="row">
  <!-- {{ row.phraseText }} -->
    {{ row.ref_type }}
</ng-template>
<ng-template #is_phrase_ref let-row="row">
  <a *ngIf="!canRemovePhrase(row)"  [class.disabled]="disabled" (click)="add(row)"
    >{{ "translate.general.add" | translate }}
  </a>
  <a *ngIf="canRemovePhrase(row)" class="c-warn"  [class.disabled]="disabled" (click)="remove(row)"
    >{{ "translate.general.remove" | translate }}
  </a>
</ng-template>
